/**
 * Enum for the different types of aggregations available for widgets
 * @enum {string}
 * @readonly
 */
export const AggregationTypes = Object.freeze({
  /** Count */
  COUNT: 'count',

  /** Average */
  AVG: 'avg',

  /** Minimum */
  MIN: 'min',

  /** Maximum */
  MAX: 'max',

  /** Sum */
  SUM: 'sum',

  /** Custom aggregation expression */
  CUSTOM: 'custom'
});
